export default "__VITE_ASSET__aLGw8lmA__"